const Hero = () => {
  return (
    <section className="pt-32 pb-16 md:pt-40 md:pb-24 bg-gradient-to-b from-bingo-50 to-white">
      <div className="container-wide">
        <div className="max-w-3xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-bingo-100 text-bingo-700 px-4 py-2 rounded-full text-sm font-medium mb-8">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-bingo-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-bingo-500"></span>
            </span>
            Since 2010 - One of the first on the App Store
          </div>

          {/* Headline */}
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            The Original
            <br />
            <span className="text-bingo-600">Meeting Survival Tool</span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Turn tedious meetings into a game. Mark corporate buzzwords as you hear them.
            First to complete a row wins. Stay engaged, stay awake, stay sane.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://apps.apple.com/app/bs-bingo/id381394933"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              Download for iOS
            </a>
            <a href="#features" className="btn-secondary">
              See how it works
            </a>
          </div>

          {/* Hero Image Placeholder */}
          <div className="mt-16 relative">
            <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl aspect-[16/10] flex items-center justify-center border border-gray-200 shadow-2xl">
              <div className="text-center p-8">
                <div className="w-16 h-16 bg-bingo-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <span className="text-3xl">🎯</span>
                </div>
                <p className="text-gray-500 text-sm">App screenshot coming soon</p>
              </div>
            </div>
            {/* Decorative elements */}
            <div className="absolute -z-10 top-8 -left-4 w-72 h-72 bg-bingo-200 rounded-full blur-3xl opacity-30"></div>
            <div className="absolute -z-10 top-8 -right-4 w-72 h-72 bg-accent/20 rounded-full blur-3xl opacity-30"></div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
